import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHexagonExclamation } from "@fortawesome/pro-light-svg-icons";
import '../App.scss';
/*import TagManager from 'react-gtm-module';*/
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'error'
//    },
//    dataLayerName: 'ErrorPageDataLayer'
//}
export default function Error(props: any) {
    if (props.setCurrentPage !== undefined) {
        props.setCurrentPage(0);
    }

    if (props.setSidebarVisibility !== undefined) {
        props.setSidebarVisibility(false);
    }

    const location = useLocation();
    let navigate = useNavigate();
    let errorLogId = localStorage.getItem("errorLogId") ? localStorage.getItem("errorLogId") : "";
    let errorLogStringId = "";

    const getStringErrorCode = () => {
        if (errorLogId != null) {
            for (let i = 0; i < errorLogId.length; i++) {
                errorLogStringId = errorLogStringId + String.fromCharCode(64 + parseInt(errorLogId[i]));
            }
            errorLogStringId = errorLogStringId.replaceAll("@", "O");
        }
    }

    getStringErrorCode();


    /*TagManager.dataLayer(tagManagerArgs);*/
    if (localStorage.getItem('customerDetails') !== null) {
        tracking(Action.SAVE_ERROR);
    }

    return (
        <div className="notification-container">
            <span>
                {/*Alert icon*/}
                <FontAwesomeIcon className="alert-icon" icon={faHexagonExclamation} />

                {/* Error title and message */}
                {location.state ? (
                    <>
                        {/* Customised error title and message */}
                        <p className="notification-title">{location.state.errorTitle}</p>
                        <p className="notification-message">{location.state.errorMessage}</p>
                    </>
                ) : (
                    <>
                        {/* Default error title and message */}
                        <p className="notification-title">{props.errorTitle}</p>
                        <p className="notification-message">{props.errorMessage}</p>
                            {errorLogId !== "" &&
                                <p>Please contact us quoting error code: {errorLogId}-{errorLogStringId}</p>}
                    </>
                )}

                {/*Go back button*/}
                <button className="notification-button" onClick={() => navigate(-1)}>Go Back</button>
            </span>
        </div>
    );
};